export enum TelemetrySdkEventGroup {
    Default = "default",
    Error = "error",
    RateLimiter = "rate_limiter"
}
